function animate(opts) {
  setTimeout(() => {
    const now = Date.now() - opts.start;
    const progress = now / opts.duration;
    const result = (opts.to - opts.from) * opts.delta(progress) + opts.from;

    if (progress <= 1) {
      animate(opts);
      opts.callback(result);
    }

    opts.callback(result);
  }, 1000 / 60);
}

export default animate;
